import { TypedDocumentNode, gql } from '@apollo/client';
import { CSSProperties } from 'react';
import styled from 'styled-components';

import {
  LineupLayout as GenericLineupLayout,
  Props as GenericLineupLayoutProps,
} from '@sorare/gameplay/src/layouts/LineupLayout';

import { useLoadPreviousLineup } from 'hooks/useLoadPreviousLineup';

import { FootballLineupLayout_so5LeaderboardContender } from './__generated__/index.graphql';
import field from './assets/field.jpg';

const StyledLineupLayout = styled(GenericLineupLayout)`
  &:before {
    content: '';

    position: absolute;
    inset: 0;

    background-image: var(--bg);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center var(--triple-unit);
    background-color: var(--c-black);
  }
`;

type Props = GenericLineupLayoutProps & {
  so5LeaderboardContender?: FootballLineupLayout_so5LeaderboardContender;
};

export const LineupLayout = ({ so5LeaderboardContender, ...props }: Props) => {
  const loadPreviousLineup = useLoadPreviousLineup({
    so5LeaderboardSlug: so5LeaderboardContender?.so5Leaderboard.slug || '',
  });

  return (
    <StyledLineupLayout
      style={
        {
          '--bg': `url(${so5LeaderboardContender?.so5Leaderboard.stadiumUrl || field})`,
        } as CSSProperties
      }
      so5LeaderboardContender={so5LeaderboardContender}
      onLoadPreviousLineup={loadPreviousLineup}
      {...props}
    />
  );
};

LineupLayout.fragments = {
  so5LeaderboardContender: gql`
    fragment FootballLineupLayout_so5LeaderboardContender on So5LeaderboardContender {
      slug
      so5Leaderboard {
        slug
        stadiumUrl
      }
      ...LineupLayout_so5LeaderboardContender
    }
    ${GenericLineupLayout.fragments.so5LeaderboardContender}
  ` as TypedDocumentNode<FootballLineupLayout_so5LeaderboardContender>,
};
